import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "dual-date-range-picker" }
const _hoisted_2 = { class: "ddrp__picker mb-4" }
const _hoisted_3 = { class: "ddrp__picker mb-4" }

import { ref, watch } from 'vue';
import DatePicker from '@vuepic/vue-datepicker';



export default /*@__PURE__*/_defineComponent({
  __name: 'DateRangePicker',
  props: {
    startDate: {},
    endDate: {},
    allowedDates: {},
    formatFunction: { type: Function },
    clearable: { type: Boolean },
    textInput: { type: Boolean },
    teleport: { type: Boolean },
    dark: { type: Boolean },
    yearRange: {}
  },
  emits: ["update:startDate", "update:endDate"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const format = (date: Date) => {
  if (props.formatFunction) {
    return props.formatFunction(date);
  }
  return date.toLocaleDateString();
};

const emit = __emit;


const startDateCalendar = ref();
const endDateCalendar = ref();
const startDateObj = ref<Date | null>(props.startDate ?? null);
const endDateObj = ref<Date | null>(props.endDate ?? null);
const errMessage = ref<string>('');


function handleStartDateChange(value: Date | null) {
  if (value !== null && value.getTime() !== startDateObj.value?.getTime()) {
    if (endDateObj.value && value > endDateObj.value) {
      errMessage.value = 'Start date cannot be after end date.';
      return;
    }
    startDateObj.value = value;
    emit('update:startDate', value);
    startDateCalendar.value?.closeMenu();
  }
}

function handleEndDateChange(value: Date | null) {
  if (value !== null && value.getTime() !== endDateObj.value?.getTime()) {
    if (startDateObj.value && value < startDateObj.value) {
      errMessage.value = 'End date cannot be before start date.';
      return;
    }
    
    endDateObj.value = value;
    emit('update:endDate', value);
    endDateCalendar.value?.closeMenu();
  }
}




watch(() => props.startDate, (newDate) => {
  if (newDate?.getTime() !== startDateObj.value?.getTime()) {
    startDateObj.value = newDate ?? null;
  }
});

watch(() => props.endDate, (newDate) => {
  if (newDate?.getTime() !== endDateObj.value?.getTime()) {
    endDateObj.value = newDate ?? null;
  }
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("label", { class: "text-subtitle-2 mb-2 d-block" }, "Start Date", -1)),
      _createVNode(_unref(DatePicker), {
        class: "ddrp__date-picker",
        uid: "start-picker",
        ref_key: "startDateCalendar",
        ref: startDateCalendar,
        "model-value": startDateObj.value,
        onInternalModelChange: handleStartDateChange,
        "allowed-dates": __props.allowedDates,
        format: format,
        "preview-format": format,
        clearable: __props.clearable,
        "text-input": __props.textInput,
        teleport: true,
        dark: __props.dark,
        "year-range": __props.yearRange,
        "enable-time-picker": false,
        "max-date": endDateObj.value ?? new Date(),
        "week-start": 0,
        "prevent-min-max-navigation": "",
        "six-weeks": ""
      }, null, 8, ["model-value", "allowed-dates", "clearable", "text-input", "dark", "year-range", "max-date"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _cache[1] || (_cache[1] = _createElementVNode("label", { class: "text-subtitle-2 mb-2 d-block" }, "End Date", -1)),
      _createVNode(_unref(DatePicker), {
        class: "ddrp__date-picker",
        uid: "end-picker",
        ref_key: "endDateCalendar",
        ref: endDateCalendar,
        "model-value": endDateObj.value,
        onInternalModelChange: handleEndDateChange,
        "allowed-dates": __props.allowedDates,
        format: format,
        "preview-format": format,
        clearable: __props.clearable,
        "text-input": __props.textInput,
        teleport: true,
        dark: __props.dark,
        "year-range": __props.yearRange,
        "enable-time-picker": false,
        "min-date": startDateObj.value ?? new Date(0),
        "week-start": 0,
        "prevent-min-max-navigation": "",
        "six-weeks": ""
      }, null, 8, ["model-value", "allowed-dates", "clearable", "text-input", "dark", "year-range", "min-date"])
    ])
  ]))
}
}

})